const NNNNOW_REGEX = /NNNOW/gi;
const BRAND_SITE = "WILDCRAFT";
export {
  HIDE_BRANDNAME,
  PRODUCTLISTBANNER,
  FOOTER_TEXTS,
  DOMAINREGEX,
  STATIC_FOOTER_PATHS,
  FOOTER_HIDDEN_PATHS,
  PAYMENTPAGE,
  PRICINGOVERVIEW,
  ROUTE_PATHS,
  STATIC_HEADER_ROUTES,
  STATIC_GETTYPE_RESPONSE,
  OLD_MASTER_TEMPLATES,
  SUPPORTED_GETTYPE_VALUES,
  EXCLUDE_STORY_BACKGROUND_COLOR,
  FULL_WIDTH_MASTER_TEMPLATES,
  BRAND_SPECIFIC_CONFIGS,
  MASTER_TEMPLATE_COMPONENT_MAPPING_MOBILE,
  MASTER_TEMPLATE_COMPONENT_MAPPING,
  STATIC_ROUTES,
  GETTYPE_PAGEWISE_VALUES,
  DONOT_SHOW_OCCASION_FILTER_IDS,
  PDP_CAROUSEL_MAX_LIMIT,
  CACHE_SETTINGS,
  STORAGE_KEYS,
  FB_SHARE_TITLE,
  GOOGLE_KEY,
  APP_BREAKPOINTS,
  PDP_CAROUSEL_DEFAULT_VIEWALL_TEXT,
  PDP_CAROUSEL_HEADINGS,
  PDP_CAROUSEL_SIZE,
  subPromoSeparator,
  requiredKeysForListing,
  scrollTime,
  omniViewimageBasePath,
  pageType,
  brandFilterKeys,
  test,
  filterKeys,
  searchQuerySeparator,
  priceSeparator,
  footerUrls,
  gmail,
  filterInitialLength,
  keycloak,
  blackBoltUrl,
  blackBoltVersion,
  blackboltConfig,
  expiryTime,
  HOME_PAGE_URL,
  LOGOUT_DELAY_TIME,
  STORE_CHECK_LOGOUT,
  SOMETHING_FISHY,
  MAX_TITLEDESCRIPTIONHORIGENTAL_CHARECTER_DESKTOP,
  MAX_TITLEDESCRIPTIONHORIGENTAL_CHARECTER_MOBILE,
  PINCODE_LENGTH,
  HEADER_HEIGHT,
  OVERFLOW_HIDDEN,
  OVERFLOW_AUTO,
  PIXEL_SCROLLED_LIMIT,
  APP_BROWSER,
  APP_OS,
  APP_PROMPT_KEY,
  APP_PROMPT_VALUE,
  APP_PROMPT_MESSAGE,
  APP_IMAGE,
  APP_PROMPT_OK,
  APP_PROMPT_CANCEL,
  APP_PROMPT_URL,
  AFFILIATE_EXPIRY,
  MONTHS,
  PINCODE_BLOCK_TITLE,
  PINCODE_BLOCK_DESCRIPTION,
  ADD_NEFT_TITLE,
  ADD_NEFT_FORM,
  RETURNS,
  CANCEL,
  MYORDERS_MESSAGES,
  MY_BAG_OFFER_IMAGE,
  ORDERDETAILS,
  PDP_SIZE_CHART_LABEL,
  PDP_SIZE_BLOCK_TITLE,
  PDP_QUANTITY_BLOCK_TITLE,
  PDP_SIZE_MODAL_SUBTEXT,
  SEPHORA_BRANDS,
  LOGOUT_REDIRECT_PATHS,
  PDP_PRODUCTVIEWBUTTON_TEXTS,
  GETAPP,
  NO_RESULTS,
  TERMS_AND_CONDITIONS,
  PRIVACY_POLICY,
  STATICPAGE_HEADER_COLOR_CLASSES,
  BLANK_SEARCH_MESSAGE,
  APPS,
  OrderConfirmation,
  Payment,
  PricingOverview,
  Promotions,
  RegexMethods,
  MASTERTEMPLATE,
  MAIN_CONFIG,
  URL_CONFIG,
  MOBILE_FILTER_BUTTON,
  LISTING,
  FAVNSHARE,
  CONTACT_US_V2,
  CACHINGVALS,
  META,
  CONTINUE_LOGIN_MESSAGES,
  FACEBOOK_WEBVIEW,
  GOOGLE_SUCCESS_URL,
  FACEBOOK_SUCCESS_URL,
  notToRetryURL,
  Loyalty,
  PDP_SIZE_MODAL_TITLE2
} from "arv-extends/constants";

export { default as NOT_FOUND } from "./notFound";
export { WHO_WE_ARE, CUSTOMER_CARE } from "./staticPages";
export { default as Checkout } from "./checkout";
export { default as CONTACT_US } from "./contactUs.js";
export { default as DEF_META_DATA } from "./metadata.js";
export { default as Endpoints } from "./endPoints.js";
import * as TOPBAR from "./topbar.js";
export { BRAND_NAME, PASTEL_COLOR_SET, COPYRIGHT_TEXT, BREADCRUMB_HOME, facebook, UTM_KEYS } from "./common.js";

export { default as FOOTER } from "./footer.js";
export { PDP_COMPONENTS, PDP_RETURNS, PDP_SIZE_MODAL_TITLE } from "./pdp.js";
export { SOLID_COLOR_SET, PDP_CONFIG } from "./product.js";
export { default as ROUTES } from "./staticRoutes";
export { LOGIN } from "./login.js";
export { default as CORPORATE_GIFTING_COMPONENTS } from "./corporateGifting.js";
export { default as WARRANTY_EXTENSION_COMPONENT } from "./warrantyExtension.js";
export { default as MyBag } from "./myBag.js";
export { default as PROMOTIONS } from "./promotion.js";
export { default as FAVORITESPAGE } from "./favorites.js";
export { default as MYACCOUNTPAGE } from "./myaccount.js";
export { MASTER_TEMPLATE_COMPONENT_CONFIGS } from "./masterTemplate.js";
export { LOGMAN_SERVICE_NAME } from "./analytics";

export { NNNNOW_REGEX, BRAND_SITE };
export { default as SHOP_MULTILPE } from "./multishop";
export { default as HEADER } from "./header";
import * as STORE_LOCATOR from "./storelocator.js";
export { default as CIRCLE_PROGRAM } from "./circleProgram.js";
export { default as SCHEMA } from "./schema.js";

export { TOPBAR , STORE_LOCATOR };